import { combineReducers, Reducer } from 'redux';
import mainReducer, { Model as MainModel, defaultState as mainState } from '../services/main/main.reducer';
import mapReducer, {
  Model as MapModel, defaultState as mapState,
} from '../services/map/map.reducer';
import quyHoachReducer, {
  Model as QuyHoachModel, defaultState as quyHoachState,
} from '../services/map/quy-hoach/quyhoach.reducer';
import suCoReducer, {
  Model as SuCoModel, defaultState as sucoState,
} from '../services/map/SuCo/suco.reducer';
import traCuuThongTinQuyHoachReducer, { TraCuuThongTinQuyHoachModel, traCuuThongTinQuyHoachDefaultState } from '../services/map/tra-cuu-thong-tin-quy-hoach/tracuuthongtinquyhoach.reducer';
import quanLyQuyHoachReducer, { QuanLyQuyHoachModel, quanLyQuyHoachDefaultState } from '../services/map/quan-ly-quy-hoach/quanlyquyhoach.reducer';
import quanLyHaTangKyThuatReducer, { QuanLyHaTangKyThuatModel, quanLyHaTangKyThuatDefaultState } from '../services/map/quan-ly-ha-tang-ky-thuat/quanlyhatangkythuat.reducer';
import { connectRouter, RouterState, LocationChangeAction } from 'connected-react-router';
import { History } from 'history';

export type AllModelReducer = {
  router?: any,
  main: MainModel,
  map: MapModel,
  quyHoach: QuyHoachModel,
  mapSuCo: SuCoModel,
  traCuuThongTinQuyHoach: TraCuuThongTinQuyHoachModel,
  quanLyQuyHoach: QuanLyQuyHoachModel,
  quanLyHaTangKyThuat: QuanLyHaTangKyThuatModel,
};

export const initialState: AllModelReducer = {
  main: mainState,
  map: mapState,
  quyHoach: quyHoachState,
  mapSuCo: sucoState,
  traCuuThongTinQuyHoach: traCuuThongTinQuyHoachDefaultState,
  quanLyQuyHoach: quanLyQuyHoachDefaultState,
  quanLyHaTangKyThuat: quanLyHaTangKyThuatDefaultState,
};
const reducers = (history: History) => combineReducers<AllModelReducer>({
  router: connectRouter(history),
  main: mainReducer,
  map: mapReducer,
  quyHoach: quyHoachReducer,
  mapSuCo: suCoReducer,
  traCuuThongTinQuyHoach: traCuuThongTinQuyHoachReducer,
  quanLyQuyHoach: quanLyQuyHoachReducer,
  quanLyHaTangKyThuat: quanLyHaTangKyThuatReducer,
});

export default reducers;
